import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DeliveryOrdersComponent } from "./delivery-orders/delivery-orders.component";
import { DriversComponent } from "./drivers/drivers.component";
import { MappingComponent } from "./mapping/mapping.component";
import { DriverOrdersComponent } from "./driver-orders/driver-orders.component";
import { OrdersComponent } from "./orders/orders.component";
import { PaymentsComponent } from "./payments/payments.component";
import { ProfileComponent } from "./profile/profile.component";
import { ReportsComponent } from "./reports/reports.component";
import { TrackComponent } from "./track/track.component";
import { TrucksComponent } from "./trucks/trucks.component";
import { PreOrdersComponent } from "./pre-orders/pre-orders.component";
import { PreorderSettingsComponent } from "./preorder-settings/preorder-settings.component";
import { NotificationsComponent } from "./notifications/notifications.component";

const routes: Routes = [
  {
    path: "transporter",
    children: [
      {
        path: "trucks",
        component: TrucksComponent,
      },
      {
        path: "drivers",
        component: DriversComponent,
      },
      {
        path: "mapping",
        component: MappingComponent,
      },
      {
        path: "driver-orders",
        component: DriverOrdersComponent,
      },
      {
        path: "orders",
        component: OrdersComponent,
      },

      {
        path: "payments",
        component: PaymentsComponent,
      },
      {
        path: "track",
        component: TrackComponent,
      },
      {
        path: "delivery-orders",
        component: DeliveryOrdersComponent,
      },
      {
        path: "reports",
        component: ReportsComponent,
      },
      {
        path: "profile",
        component: ProfileComponent,
      },
      {
        path: "pre-orders",
        component: PreOrdersComponent,
      },
      {
        path: "pre-order-settings",
        component: PreorderSettingsComponent,
      },
      {
        path: "notifications",
        component: NotificationsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TruckOwnerRoutingModule {}
